import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="container-x py-32 text-center" data-testid="not-found">
      <p className="font-display text-7xl font-black text-[var(--leaf)]">404</p>
      <h1 className="font-display text-3xl font-bold mt-4">Página não encontrada</h1>
      <p className="text-slate-600 mt-2">O conteúdo que procura pode ter mudado de lugar.</p>
      <Link to="/" className="mt-8 inline-flex h-12 px-6 items-center rounded-full bg-[var(--ink)] text-white font-semibold">Voltar ao início</Link>
    </div>
  );
}
